import { FC } from "react";
import ClientTable from "./Table";

const ClientPage: FC = () => <ClientTable />;

export default ClientPage;
